import type { Editor } from "@tiptap/core"
import { useEffect, useState } from "react"

import { TableEvent } from "../TableEvent"
import { TableColumnMenu } from "./TableColumnMenu"
import { TableRowMenu } from "./TableRowMenu"

interface TableHandlesMenusProps {
  editor: Editor
}

export function TableFloatingMenus(props: TableHandlesMenusProps) {
  return (
    <>
      <TableRowFloatingMenu {...props} />
      <TableColumnFloatingMenu {...props} />
    </>
  )
}

function TableRowFloatingMenu(props: TableHandlesMenusProps) {
  const { editor } = props
  const { triggerElement, open, onOpenChange } = useTableMenuState(
    "row",
    editor,
  )

  return (
    <TableRowMenu
      open={open}
      editor={editor}
      triggerElement={triggerElement}
      onOpenChange={onOpenChange}
    />
  )
}

function TableColumnFloatingMenu(props: TableHandlesMenusProps) {
  const { editor } = props
  const { triggerElement, open, onOpenChange } = useTableMenuState(
    "column",
    editor,
  )

  return (
    <TableColumnMenu
      open={open}
      editor={editor}
      triggerElement={triggerElement}
      onOpenChange={onOpenChange}
    />
  )
}

function useTableMenuState(type: "row" | "column", editor: Editor) {
  const [triggerElement, setTriggerElement] = useState<HTMLElement>()
  const [open, onOpenChange] = useState(false)

  useEffect(() => {
    // Listen to table handle click events and open the menu.
    return TableEvent.listen("handleClick", {
      editor,
      callback: (detail) => {
        if (detail.type !== type) return
        setTriggerElement(detail.referenceElement)
        // this setTimeout prevents the menu from briefly being displayed in the
        // previous position and jumping to the new position.
        setTimeout(() => onOpenChange(true), 0)
      },
    })
  }, [editor, type])

  return { open, onOpenChange, triggerElement }
}
